import { useQuery } from "@tanstack/react-query";
import { getNoteById } from "@/notes/api/notes";

export const useGetNode = (activeNoteId: string | null) => {
	return useQuery({
		queryKey: ["getNode", activeNoteId],
		queryFn: () => {
			if (!activeNoteId) throw new Error("No active note ID");
			return getNoteById(activeNoteId);
		},
		enabled: !!activeNoteId,
	});
};
